import { generateTestId } from "@client-shared";

export const setBatchDetailModalTestId = (identifier: string): string =>
  generateTestId("BatchDetailModal", identifier);
